import { render, staticRenderFns } from "./ac-vertical-navigation.vue?vue&type=template&id=887b5204&"
import script from "./ac-vertical-navigation.vue?vue&type=script&lang=js&"
export * from "./ac-vertical-navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports